import { useEffect, lazy, Suspense } from "react";
import { Outlet, useLocation } from "react-router";
import { SpeedInsights } from "@vercel/speed-insights/react";
import Header from "./Header";
import Footer from "./Footer";
import CookieBanner from "@/components/ui/CookieBanner";
import AnalyticsProvider from "@/components/analytics/AnalyticsProvider";
import EditorShell from "@/components/dev/EditorShell";
import JsonLd from "@/components/seo/JsonLd";

const UnoptimizedImagesBannerLazy = import.meta.env.DEV
  ? lazy(() => import("@/components/dev/UnoptimizedImagesBanner"))
  : null;

function PageContent() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="flex min-h-screen flex-col" style={{ paddingTop: "var(--dev-banner-h, 0px)" }}>
      <JsonLd
        data={{
          "@context": "https://schema.org",
          "@type": "Organization",
          name: "Chasing Provence",
          url: "https://chasingprovence.com",
          logo: "https://chasingprovence.com/images/brand/cplogo.webp",
          description:
            "Intimate women's retreats in Provence, Tuscany, and the Cotswolds. Curated gatherings of food, nature, and slow living.",
          sameAs: [
            "https://www.instagram.com/chasingprovence/",
            "https://chasingprovence.substack.com",
          ],
        }}
      />
      {UnoptimizedImagesBannerLazy && (
        <Suspense fallback={null}>
          <UnoptimizedImagesBannerLazy />
        </Suspense>
      )}
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <CookieBanner />
      <AnalyticsProvider />
      <SpeedInsights />
    </div>
  );
}

export default function PageLayout() {
  return (
    <EditorShell>
      <PageContent />
    </EditorShell>
  );
}
